import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ProductWithQuality } from '../../../../../../types/Quotes';
import { RootState } from '../../../store/redux/reducers/rootReducer';

const useOffersSortedProducts = (
  products: ProductWithQuality[],
): ProductWithQuality[] => {
  const shownProducts = useSelector(
    (state: RootState) => state.offers.shownProducts,
  );

  const shownProductsOrder = useSelector(
    (state: RootState) => state.offers.shownProductsOrder,
  );
  // Helper function to get product information by hashId
  const getProductInfo = (hashId: string) =>
    shownProducts?.find((item) => item.hashId === hashId);

  // Define a comparator function based on the sortType
  const comparator = (a: ProductWithQuality, b: ProductWithQuality) => {
    const infoA = getProductInfo(a.hash_id);
    const infoB = getProductInfo(b.hash_id);

    // If either product is not found in shownProducts, prioritize the other one
    if (shownProductsOrder) {
      if (!infoA && infoB) return 1;
      if (infoA && !infoB) return -1;
    }

    switch (shownProductsOrder) {
      case 'PRICE_ASC':
        return (infoA?.price || 0) - (infoB?.price || 0);
      case 'PRICE_DESC':
        return (infoB?.price || 0) - (infoA?.price || 0);
      case 'QUALITY_ASC':
        return (infoA?.quality || 0) - (infoB?.quality || 0);
      case 'QUALITY_DESC':
        return (infoB?.quality || 0) - (infoA?.quality || 0);
      default:
        return 0;
    }
  };

  const sortedProducts = useMemo(
    () => [...products].sort(comparator),
    [shownProductsOrder],
  );
  return sortedProducts;
};

export default useOffersSortedProducts;
